import styled from 'styled-components';

const mapSizeToStyle = {
  small: `
    width: 2em;
    height: 2em;
    margin-top: -1em;
    margin-left: -1em;
    border-radius: 1em;  
    :after{
      width: 1em;
      height: 1em;
      top: .5em;
      left: .5em;
      border-radius: .5em;
      position: absolute;
      content:"";  
    }
    :before {
      width: 2.8em;
      height: 2.8em;
      position: absolute;
      content:"";
      top: -.4em;
      left: -.4em;
      border-radius:1.4em;
    }  
  `,
  medium: `
    width: 4em;
    height: 4em;
    margin-top: -2em;
    margin-left: -2em;
    border-radius: 2em;    
    :after{
      width: 2em;
      height: 2em;
      top: 1em;
      left: 1em;
      border-radius: 1em;
      position: absolute;
      content:""; 
    }
    :before {
      width: 5.6em;
      height: 5.6em;
      top: -0.8em;
      left: -0.8em;
      border-radius: 2.8em;      
    }
  `,
  large: `
    width: 6em;
    height: 6em;
    margin-top: -3em;
    margin-left: -3em;
    border-radius: 3em;
    :after{
      width: 4em;
      height: 4em;
      top: 2em;
      left: 2em;
      border-radius: 2em;
      position: absolute;
      content:""; 
    }
    :before {
      width: 8.4em;
      height: 8.4em;
      top: -1.6em;
      left: -1.6em;
      border-radius: 5.6em;      
    }
  `,
};

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const TextContainer = styled.div`
  width: 100%;
  font-size:24px;
  padding: 9%;
  padding-top: 0;
  position: relative;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const GearsContainer = styled.div`
  width: 100%; 
  font-size:24px;
  padding: 9%;
  position: relative; 
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 65px;

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes rotating {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @-webkit-keyframes rotating-left /* Safari and Chrome */ {
    from {
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(-360deg);
      -o-transform: rotate(-360deg);
      transform: rotate(-360deg);
    }
  }
  @keyframes rotating-left {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(-360deg);
      -moz-transform: rotate(-360deg);
      -webkit-transform: rotate(-360deg);
      -o-transform: rotate(-360deg);
      transform: rotate(-360deg);
    }
  }

`;

export const GearContainer = styled.div`
  // based on props move the content up or down by an offset
  ${({ offset }) => offset && `
    margin-top: ${offset}px;
  `}
`;

export const Gear = styled.div`

  ${({ theme }) => `
    background: ${theme.color.button};
    top: 50%;
    left: 50%;
    position: relative;

    &:after{
      width: 1em;
      height: 1em;
      top: .5em;
      left: .5em;
      border-radius: .5em;
      background:  ${theme.color.buttonActive};
      position: absolute;
      content:"";    
    }

    &:before {
      width: 2.8em;
      height: 2.8em;
      background: 
        -webkit-linear-gradient(0deg,transparent 39%,${theme.color.button} 39%,${theme.color.button} 61%, transparent 61%),
        -webkit-linear-gradient(60deg,transparent 42%,${theme.color.button} 42%,${theme.color.button} 58%, transparent 58%),
        -webkit-linear-gradient(120deg,transparent 42%,${theme.color.button} 42%,${theme.color.button} 58%, transparent 58%);
      background: 
        -moz-linear-gradient(0deg,transparent 39%,${theme.color.button} 39%,#47EC19 61%, transparent 61%),
        -moz-linear-gradient(60deg,transparent 42%,${theme.color.button} 42%,${theme.color.button} 58%, transparent 58%),
        -moz-linear-gradient(120deg,transparent 42%,${theme.color.button} 42%,${theme.color.button} 58%, transparent 58%);
      background: 
        -o-linear-gradient(0deg,transparent 39%,${theme.color.button} 39%,${theme.color.button} 61%, transparent 61%),
        -o-linear-gradient(60deg,transparent 42%,${theme.color.button} 42%,${theme.color.button} 58%, transparent 58%),
        -o-linear-gradient(120deg,transparent 42%,#47EC19 42%,${theme.color.button} 58%, transparent 58%);
      background: -ms-linear-gradient(0deg,transparent 39%,${theme.color.button} 39%,${theme.color.button} 61%, transparent 61%),
        -ms-linear-gradient(60deg,transparent 42%,${theme.color.button} 42%,${theme.color.button} 58%, transparent 58%),
        -ms-linear-gradient(120deg,transparent 42%,${theme.color.button} 42%,${theme.color.button} 58%, transparent 58%);
      background: 
        linear-gradient(0deg,transparent 39%,${theme.color.button} 39%,${theme.color.button} 61%, transparent 61%),
        linear-gradient(60deg,transparent 42%,${theme.color.button} 42%,${theme.color.button} 58%, transparent 58%),
        linear-gradient(120deg,transparent 42%,${theme.color.button} 42%,${theme.color.button} 58%, transparent 58%);
      position: absolute;
      content:"";
      top: -.4em;
      left: -.4em;
      border-radius:1.4em;
    }
  `}

 
  ${({ size }) => mapSizeToStyle[size] || mapSizeToStyle.small}
  

  -webkit-animation: rotating 2s linear infinite;
  -moz-animation: rotating 2s linear infinite;
  -ms-animation: rotating 2s linear infinite;
  -o-animation: rotating 2s linear infinite;
  animation: rotating 2s linear infinite;

  // get the direction the gear should rotate via props
  ${(props) => props.direction === 'left' && `
    -webkit-animation: rotating-left 2s linear infinite;
    -moz-animation: rotating-left 2s linear infinite;
    -ms-animation: rotating-left 2s linear infinite;
    -o-animation: rotating-left 2s linear infinite;
    animation: rotating-left 2s linear infinite;
  `}
`;
